import { FileType } from "src/types/main";
import { CapacitorHttp } from "@capacitor/core";
import { FileOpener } from "@capacitor-community/file-opener";
import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";
import { SaveToDownloads } from "../helpers/saveToDownloads";

export const downloadForApp = async (file: FileType) => {
  try {
    const { value: token } = await SecureStoragePlugin.get({
      key: "accessToken",
    });

    const response = await CapacitorHttp.request({
      method: "GET",
      url: file.FileRef,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "arraybuffer",
    });

    if (response.status !== 200) {
      throw new Error(`HTTP ${response.status}`);
    }

    const base64Data = response.data as string;

    const mimeType = getMimeType(file.FileLeafRef);

    const saved = await SaveToDownloads.save({
      fileName: file.FileLeafRef,
      data: base64Data,
      mimeType,
    });

    console.log("Файл сохранён в Download:", saved.uri);

    await FileOpener.open({
      filePath: saved.uri,
      contentType: mimeType,
    });
  } catch (error) {
    console.error("Ошибка скачивания:", error);
    throw error;
  }
};

const getMimeType = (fileName: string): string => {
  const extension = fileName.split(".").pop()?.toLowerCase();

  const mimeTypes: Record<string, string> = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    mp4: "video/mp4",
    txt: "text/plain",
    zip: "application/zip",
  };

  return mimeTypes[extension ?? ""] ?? "application/octet-stream";
};
